module.exports = __webpack_public_path__ + "static/media/May 2022 - April 2023 Performance Review.741fcabc.pdf";